import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=716d3e02&scoped=true&"
import script from "./Asset.vue?vue&type=script&lang=js&"
export * from "./Asset.vue?vue&type=script&lang=js&"
import style0 from "./Asset.vue?vue&type=style&index=0&id=716d3e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716d3e02",
  null
  
)

export default component.exports